<template>
    <v-sheet
     v-if="pdfSource"
     class="elevation-1"
     >
        <PDFView 
            class="elevation-16" 
            :source="pdfSource"
            :page="currentPage" 
         />
    </v-sheet>

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PDFView from 'vue-pdf-embed';
export default defineComponent({
    name: 'SlidePreview-Componenten',

    props: {
        pdfSource: String,
        currentPage: Number,
    },

    components: {
        PDFView
    },
});
</script>

<style scoped>

</style>